import type { PaymentGatewayTerminalSaleResult } from '../gateway-terminal-sale.types';
import type { CardPointeTerminalSaleResponseDetails } from './cardpointe-terminal-sale-response.types';

export const CardPointeLifecycleFinalizationGatewayOperation = {
    TERMINAL_SALE: 'terminal_sale',
} as const;

export type CardPointeLifecycleFinalizationGatewayOperation =
    (typeof CardPointeLifecycleFinalizationGatewayOperation)[keyof typeof CardPointeLifecycleFinalizationGatewayOperation];

export const CardPointeLifecycleFinalizationPayloadType = {
    REQUEST: 'cardpointe_lifecycle_finalization_request_v1',
    RESPONSE: 'cardpointe_lifecycle_finalization_response_v1',
} as const;

export type CardPointeLifecycleFinalizationPayloadType =
    (typeof CardPointeLifecycleFinalizationPayloadType)[keyof typeof CardPointeLifecycleFinalizationPayloadType];

export const CardPointeLifecycleFinalizationOutcome = {
    FINALIZED: 'finalized',
    MALFORMED_RESULT: 'malformed_result',
} as const;

export type CardPointeLifecycleFinalizationOutcome =
    (typeof CardPointeLifecycleFinalizationOutcome)[keyof typeof CardPointeLifecycleFinalizationOutcome];

export interface CardPointeLifecycleFinalizationRequestDetails {
    readonly gateway_operation: typeof CardPointeLifecycleFinalizationGatewayOperation.TERMINAL_SALE;
    readonly terminal_sale_response_details: CardPointeTerminalSaleResponseDetails;
    readonly terminal_sale_result: PaymentGatewayTerminalSaleResult;
}

export interface CardPointeLifecycleFinalizationNormalizedResult {
    readonly gateway_operation: typeof CardPointeLifecycleFinalizationGatewayOperation.TERMINAL_SALE;
    readonly status: PaymentGatewayTerminalSaleResult['status'];
    readonly gateway_transaction_id?: string;
    readonly approved_amount?: string;
    readonly authorization_code?: string;
    readonly batch_id?: string;
    readonly masked_account?: string;
    readonly gateway_token?: string;
    readonly message?: string;
    readonly response_code?: string;
}

export type CardPointeLifecycleFinalizationResponseDetails =
    | {
          readonly outcome: typeof CardPointeLifecycleFinalizationOutcome.FINALIZED;
          readonly normalized_result: CardPointeLifecycleFinalizationNormalizedResult;
      }
    | {
          readonly outcome: typeof CardPointeLifecycleFinalizationOutcome.MALFORMED_RESULT;
          readonly message: string;
          readonly body: unknown;
      };

export interface CardPointeLifecycleFinalizationRequestPayload {
    readonly gateway_lifecycle_payload_type: typeof CardPointeLifecycleFinalizationPayloadType.REQUEST;
    readonly request_details: CardPointeLifecycleFinalizationRequestDetails;
}

export interface CardPointeLifecycleFinalizationResponsePayload {
    readonly gateway_lifecycle_payload_type: typeof CardPointeLifecycleFinalizationPayloadType.RESPONSE;
    readonly response_details: CardPointeLifecycleFinalizationResponseDetails;
}

export type CardPointeLifecycleFinalizationPayload =
    | CardPointeLifecycleFinalizationRequestPayload
    | CardPointeLifecycleFinalizationResponsePayload;
